import {initDetailByAPI} from '@web/actions/detail'
import makeSlice from '@web/slices/personalCustomsClearance/sliceMaker'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(initDetailByAPI.fulfilled, (state, {payload}) => {
            if (payload.data.deliveryAddress.personalCustomsCodeInfo) {
                state.selected.view = payload.data.deliveryAddress.personalCustomsCodeInfo.code
                state.selected.hash = payload.data.deliveryAddress.personalCustomsCodeInfo.hash
            }
        })
    },
})

export default slice.reducer
